import { useEffect } from "react";
import { SessionAction, Shell, StatusPill } from "../components";
import { setPageMetadata } from "../page-metadata";

export function SquadTacticalPlannerPage() {
  useEffect(() => {
    setPageMetadata(
      "战术小队赛前规划器（开发中）| CheemsPay",
      "战术小队赛前规划器：围绕一场比赛表达赛前战术意图的独立开发中工具。",
    );
  }, []);

  return (
    <Shell
      action={
        <SessionAction signedOutReturnTo="/products/squad-tactical-planner" />
      }
      activeItem="squad"
    >
      <section className="preview-page">
        <section className="preview-hero">
          <div className="preview-copy">
            <h1>把一场比赛的想法，先放到地图上。</h1>
            <p className="preview-lead">
              围绕单场《战术小队》对局的地图工具，让队长和队员在开局前对齐同一套计划。
            </p>
            <StatusPill tone="warn">开发中 · 暂未开放购买</StatusPill>
            <p className="preview-disclosure">
              功能、发布时间和价格确定后会在这里更新。
            </p>
            <a className="button button-secondary preview-cta" href="/contact">
              联系支持
            </a>
          </div>

          <div aria-label="抽象战术地图示意图" className="tactical-illustration" role="img">
            <svg aria-hidden="true" viewBox="0 0 640 470">
              <defs>
                <pattern id="tactical-grid" height="32" patternUnits="userSpaceOnUse" width="32">
                  <path d="M 32 0 L 0 0 0 32" fill="none" stroke="#9bc3b0" strokeOpacity=".27" strokeWidth="1" />
                </pattern>
                <linearGradient id="tactical-ground" x1="0" x2="1" y1="0" y2="1">
                  <stop offset="0" stopColor="#d9ebd5" />
                  <stop offset="1" stopColor="#b8d3c3" />
                </linearGradient>
              </defs>
              <rect fill="url(#tactical-ground)" height="470" rx="28" width="640" />
              <rect fill="url(#tactical-grid)" height="470" rx="28" width="640" />
              <path d="M-20 370 C110 295 128 420 250 332 S405 198 670 250" fill="none" stroke="#6aa28b" strokeOpacity=".45" strokeWidth="54" />
              <path d="M-18 370 C112 297 131 422 250 334 S408 201 670 252" fill="none" stroke="#edf7df" strokeOpacity=".9" strokeWidth="3" />
              <path d="M80 70 L250 132 L206 256 L350 318 L535 116" fill="none" stroke="#f7f0c5" strokeDasharray="12 12" strokeWidth="8" />
              <path d="M80 70 L250 132 L206 256 L350 318 L535 116" fill="none" stroke="#4f7667" strokeOpacity=".75" strokeWidth="2" />
              <path d="M102 402 C177 330 198 256 306 242 S430 142 553 87" fill="none" stroke="#e4a91c" strokeDasharray="10 9" strokeLinecap="round" strokeWidth="5" />
              <path d="M306 242 L290 251 L301 262" fill="none" stroke="#e4a91c" strokeLinecap="round" strokeWidth="5" />
              <path d="M454 314 L530 337 L566 294 L507 270 Z" fill="#f3a5b7" fillOpacity=".63" stroke="#9c5369" strokeWidth="3" />
              <path d="M126 164 L175 133 L206 169 L182 212 L131 220 Z" fill="#bca3ef" fillOpacity=".7" stroke="#65538f" strokeWidth="3" />
              <circle cx="250" cy="132" fill="#fffdf8" r="14" stroke="#1f1e1a" strokeWidth="4" />
              <circle cx="250" cy="132" fill="#1f1e1a" r="4" />
              <circle cx="350" cy="318" fill="#fffdf8" r="14" stroke="#1f1e1a" strokeWidth="4" />
              <circle cx="350" cy="318" fill="#1f1e1a" r="4" />
              <path d="M566 91 l12 22 24 3-18 16 5 24-23-11-22 11 5-24-18-16 24-3z" fill="#f6c945" stroke="#1f1e1a" strokeWidth="3" />
              <g fill="#315047" fontFamily="Segoe UI, Microsoft YaHei, sans-serif" fontSize="14" fontWeight="800">
                <text x="224" y="106">集结点</text>
                <text x="323" y="354">推进线</text>
                <text x="470" y="363">控制区</text>
                <text x="105" y="250">备用路线</text>
              </g>
            </svg>
            <div className="tactical-illustration-caption">
              <span>单场赛前</span>
              <strong>地图、路线、区域、备注</strong>
            </div>
          </div>
        </section>

        <section className="preview-sections">
          <article className="preview-card">
            <span className="card-kicker">计划中</span>
            <h2>让队友在开局前读懂同一张图。</h2>
            <ul className="preview-list">
              <li>选择地图和图层</li>
              <li>放置标记和备注</li>
              <li>绘制路线、扇区和区域</li>
              <li>整理一份赛前可以一起看的计划</li>
            </ul>
          </article>
          <article className="preview-card preview-card-exclusion">
            <span className="card-kicker">范围</span>
            <h2>只做赛前规划</h2>
            <p>
              不管理报名、赛程、积分或对阵。这是独立开发的伴随工具，不是官方游戏产品。
            </p>
            <p>
              目前没有价格和购买入口。
            </p>
          </article>
        </section>
      </section>
    </Shell>
  );
}
